export default __webpack_public_path__ + "images/cc11f2a0078195c75862d0fce3be28a6-tou.svg";